import BaseService from '../../base/base_service';
import {
  IElasticEventData,
  IStructuredLogger
} from '../../../../common/interfaces/structured-logging-service-interface';
import ElasticLogger from "./elastic_logger";
import StructuredLoggingServiceInterface, {DEFAULT_LOGS_TARGET} from './structured_logging_service_interface';


export default class StructuredLoggingService extends BaseService implements StructuredLoggingServiceInterface {
    static CLASS = 'StructuredLoggingService';
    private _environment: string;
    private _storageUrl: string;


    init(params) {
        super.init(params);
        this._storageUrl = params.storageUrl;
        this._environment = params.environment;
    }

    getLogger(eventData?: IElasticEventData): IStructuredLogger {
        return this._createElasticLogger(eventData || {});
    }

    getEnvironment(): string {
        return this._environment;
    }

    private _createElasticLogger(eventData: IElasticEventData): IStructuredLogger {
        return ElasticLogger.create({
            serviceFactory: this.serviceFactory,
            environment: this._environment,
            storageUrl: this._storageUrl,
            eventData: eventData
        });
    }

    async writeWidgetLogs(payload: any): Promise<void> {
        if(payload?.eventHeader?.target?.toString()?.toLowerCase() === DEFAULT_LOGS_TARGET) {
            throw new Error("Widgets cannot log into the client target. Please change payload.eventHeader.target");
        }

        await this.serviceFactory.http2Service().postJSON(this._storageUrl, {body : payload, keepalive : true});
    }
}
